<template>
  <div>
    <v-autocomplete
      v-model="deviceSelected"
      dense
      outlined
      item-text="imei"
      :label="label"
      :items="deviceList"
      return-object
      :readonly="readonly"
      @change="save"
      :rules="rules"
      :filter="filter"
      :item-disabled="isItemDisabled"
      :loading="loading || loadingSearch"
      :clearable="!readonly"
    >
      <template v-slot:selection="data">
        <template>
          {{ data.item.imei }} - {{ data.item.fabricante }} {{ data.item.modelo }}
        </template>
      </template>

      <template v-slot:item="data">
        <template>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.imei }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ data.item.fabricante }} {{ data.item.modelo }}
              {{ data.item.pessoa !== '' && data.item.pessoa != null ? ' - '+data.item.pessoa : '' }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { debounce } from "lodash";

export default {
  props: {
    selectedDevice: {
      type: [Object, Array],
      default: () => {},
    },
    label: {
      type: String,
      default: 'Aparelho'
    },
    rules: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deviceSelected: {},
      deviceList: [],
      loading: true,
      debounceFetchMoreDevice: null,
      loadingSearch: false,
    };
  },
  async mounted() {
    try {
      if (this.selectedDevice && Object.keys(this.selectedDevice).length > 0) {
        this.deviceSelected = this.selectedDevice;
      }
      if (this.readonly) {
        this.deviceList = [this.deviceSelected];
      } else {
        await this.loadDevices();
        this.deviceList = this.devices;
      }
      this.loading = false;
    } catch (e) {
      await this.$swal("Oops...", e.message, "error");
    }
  },
  computed: {
    ...mapState("device", ["devices"]),
  },
  methods: {
    ...mapActions("device", ["loadDevices"]),

    isItemDisabled(item) {
      return item.id_aparelho === null;
    },

    filter(item, queryText) {
      const searchText = queryText.toLowerCase();

      if (!searchText) {
        return true;
      }

      if (this.lastSearchQuery !== searchText) {
        this.lastSearchQuery = searchText;
        if (!this.debounceFetchMoreDevice) {
          this.debounceFetchMoreDevice = debounce(this.loadDeviceFilter, 500);
        }
        this.debounceFetchMoreDevice(searchText);
      }

      return true;
    },

    async loadDeviceFilter() {
      if (!this.readonly) {
        this.loadingSearch = true;
        try {
          const params = { search: this.lastSearchQuery};
          await this.loadDevices(params);
          if (this.devices && this.devices.length > 0) {
            this.deviceList = this.devices;
          }else {
            this.deviceList = [{ imei: "Nenhum aparelho encontrado", fabricante: '', modelo: '', id_aparelho: null }];
          }
          this.loadingSearch = false;
        } catch (error) {
          await this.$swal("Oops...", 'Erro ao buscar aparelho', "error");
          this.deviceList = [{ imei: "Nenhum aparelho encontrado", fabricante: '', modelo: '', id_aparelho: null }];
        }
      }
    },

    save (value) {
      if (!this.readonly) {
        if (!value) value = {};
        this.$emit("save", value);
      }
    }
  },
  watch: {
    selectedDevice(newVal) {
      if (this.deviceSelected !== newVal) {
        this.deviceSelected = newVal;
      }
    }
  },
};
</script>
<style scoped></style>
